export default __webpack_public_path__ + "static/media/Blossoming Death.ab5d3fbb.jpg";